var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoodreads(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "la:goodreads"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.625 5.625V30.375H30.375V5.625H5.625ZM7.875 7.875H28.125V28.125H7.875V7.875ZM17.4375 10.125C14.6464 10.125 12.375 12.6484 12.375 15.75C12.375 18.8516 14.6464 21.375 17.4375 21.375C19.0361 21.375 20.4469 20.5313 21.375 19.242V20.8125C21.375 22.9837 19.6087 24.75 17.4375 24.75C16.6951 24.747 15.9687 24.5341 15.3421 24.136C14.7155 23.7379 14.2142 23.1708 13.896 22.5H12.6844C13.383 24.4597 15.2404 25.875 17.4375 25.875C20.2286 25.875 22.5 23.6036 22.5 20.8125V11.25H21.375V12.258C20.4469 10.9687 19.0361 10.125 17.4375 10.125ZM17.4375 11.25C19.6087 11.25 21.375 13.2682 21.375 15.75C21.375 18.2318 19.6087 20.25 17.4375 20.25C15.2663 20.25 13.5 18.2318 13.5 15.75C13.5 13.2682 15.2663 11.25 17.4375 11.25Z",
    fill: "var(--fill-0, #5A5F6A)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodreads);
export default __webpack_public_path__ + "static/media/goodreads.50d280ab86942664794ce43d76bf3872.svg";
export { ForwardRef as ReactComponent };